import { combineReducers } from "redux";

import homebanner from "../features/components/homepage/homebanner/Slice";

import ourguidance from "../features/components/homepage/ourguidance/Slice";

import moments from "../features/components/homepage/moments/Slice";

import publishedbook from "../features/components/homepage/publishedbook/Slice";

import common from "../features/components/common/Slice";

const homepage = combineReducers({
  homebanner,
  ourguidance,
  moments,
  publishedbook,
  common,
});

export default homepage;
